/* ============================================================
   Alice Lane — Insider Program: Meta "Lead" event
   - Sends the Meta pixel's standard Lead event once, when the
     section's Klaviyo embed form is submitted successfully
     (Klaviyo's window-level "klaviyoForms" event, type "submit").
   - Only with marketing consent (Shopify Customer Privacy API).
   - Reuses the Facebook & Instagram app's pixel when it is on the
     page; otherwise loads the pixel for this one event (no
     PageView, no automatic events).
   - Each Lead carries a unique eventID, Meta's deduplication key.
   Loaded by sections/insider-signup.liquid when "Send Meta Lead
   event on signup" is on.
   ============================================================ */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script || (window.Shopify && window.Shopify.designMode)) return;

  var pixelId = (script.dataset.pixelId || '').trim();
  var formId = ((script.dataset.klaviyoEmbedClass || '').match(/klaviyo-form-([A-Za-z0-9]+)/) || [])[1];
  if (!pixelId || !formId) return;

  var sent = false;

  /* true / false from Shopify's consent API, or null when the API isn't on
     the page; then the Meta pixel only being there after consent decides. */
  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return null;
    return !!privacy.marketingAllowed();
  }

  function newEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'insider-lead-' + window.crypto.randomUUID();
    }
    return 'insider-lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  /* Meta's standard base code without the PageView: initialises only this
     pixel, with automatic events off, so the Lead is all it sends. */
  function loadPixel() {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('set', 'autoConfig', false, pixelId);
    window.fbq('init', pixelId);
  }

  function sendLead() {
    if (sent) return;
    var consent = marketingAllowed();
    if (consent === false) return;
    if (typeof window.fbq !== 'function') {
      if (consent !== true) return;
      loadPixel();
    }
    sent = true;
    window.fbq('trackSingle', pixelId, 'Lead', { content_name: 'Insider Program' }, { eventID: newEventId() });
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = (event && event.detail) || {};
    if (detail.type === 'submit' && detail.formId === formId) sendLead();
  });
})();
